<script>
  import Bleed from "$lib/components/Bleed.svelte";

  /** @type {"symmetric" | "leftWide" | "rightWide"} */
  export let columnLayout;

  let clazz = "";
  export { clazz as class };
  export let leftColumnClass;
  export let rightColumnClass;

  let columnClasses = `${leftColumnClass} ${rightColumnClass} `;
</script>

<div class="embedded-content">
  <Bleed fullWidth contentClasses="px-24 lg:px-72 {columnClasses}">
    <div
      class={`grid gap-32 lg:gap-72 grid-cols-1 px-0 ${clazz}`}
      class:lg:grid-cols-2={columnLayout === "symmetric"}
      class:lg:grid-cols-3={columnLayout !== "symmetric"}
    >
      <div
        class={`left-column self-center ${leftColumnClass}`}
        class:wide-column={columnLayout === "leftWide"}
      >
        <slot name="left" />
      </div>
      <div
        class={`right-column self-center ${rightColumnClass}`}
        class:wide-column={columnLayout === "rightWide"}
      >
        <slot name="right" />
      </div>
    </div></Bleed
  >
</div>

<style lang="postcss">
  .wide-column {
    @apply lg:col-span-2 w-fit;

    &.right-column {
      @apply order-first lg:order-last;
    }
  }
</style>
